import { render, staticRenderFns } from "./Storage.vue?vue&type=template&id=61b7d306"
import script from "./Storage.vue?vue&type=script&lang=js"
export * from "./Storage.vue?vue&type=script&lang=js"
import style0 from "./Storage.vue?vue&type=style&index=0&id=61b7d306&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports